export enum POSITION_FILTER {
  ALL = 'ALL',
  EMPTY = 'EMPTY',
  USED = 'USED',
}
